"use client";

import styles from "./info-tabs.module.scss";

const LayersTab = () => {
  return (
    <div className={styles.tabContent}>
      <h2>Map Layers & Analysis Overview</h2>
      <p>
        The <strong>AI2Peat</strong> platform features an interactive map that
        allows users to explore Ireland’s peatlands by toggling different types
        of data layers.
      </p>
      <br />

      <div className={styles.tabUnorderedList}>
        <ul>
          <li>
            <strong>All Ireland Raised Bog Ecotopes:</strong> Classified ecotope types,
            habitat distribution, and emission potential.
          </li>
          <li>
            <strong>Ecotope Mosaic:</strong> Enhanced ecotope classifications including
            updated patches and additional transitions between ecotope types.
          </li>
          <li>
            <strong>Slope Layers:</strong> Terrain gradient across peatland
            types, useful for hydrological and restoration planning.
          </li>
          <li>
            <strong>Irish Peat Soil Map – Soil Types (Gilet et al., 2024):</strong> 
            National-scale classification of peat vs. non-peat soils with subtypes such as
            Raised Bogs, Blanket Bogs, and Fens.
          </li>
          <li>
            <strong>Sharavogue Hydrology Site:</strong> Dipwell and rain data from the Living Bog Project,
            used for Specific Yield (Sy) analysis of raised bogs.
          </li>
          <li>
            <strong>Mullingar Met Station:</strong> Hourly rainfall data from the Mullingar weather station,
            used to estimate VWB response in nearby peatlands.
          </li>
            <li>
              <strong>Emission Factors:</strong> Estimated CO₂ emissions or uptake per hectare per year for each ecotope type, 
              based on field studies and scientific literature. The platform calculates carbon impact under 
              three scenarios — <em>Conservative</em>, <em>Average</em>, and <em>Non-conservative</em> — to support restoration and policy decisions.
            </li>
        </ul>
        
      </div>

      <br />
      <p>
        Together with ecotope classification and soil mapping, slope analysis
        enhances understanding of peatland conditions and supports
        evidence-based restoration planning.
      </p>
      <p>
        Visualizations like pie charts, bar graphs, and histograms are generated
        based on the selected layers.
      </p>
    </div>
  );
};

export default LayersTab;
